import React from 'react';
import FrameworkApp from './framework/FrameworkApp'


import {
    FirebaseDataProvider,
    FirebaseAuthProvider
} from "react-admin-firebase";
import firebase from 'firebase';
import "firebase/performance";
import "firebase/functions";
import UserIcon from '@material-ui/icons/People';

import {firebaseConfig} from './custom/FIREBASE_CONFIG';
import CustomLoginPage from './CustomLoginPage';

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.apps[0];
firebase.performance();
firebase.analytics();
firebase.functions();



const App = (props) => {
    return (
        <FrameworkApp loginPage={CustomLoginPage}
                      {...props}
        />
    );

}
export default App;

